import { tryOnMounted, tryOnUnmounted } from '@vueuse/core';

import { useSocketStore } from '@/stores/socket';

export function useRegisterSockets(event, callBack) {
  const socketStore = useSocketStore();

  tryOnMounted(() => {
    socketStore.addListener(event, callBack);
  });

  tryOnUnmounted(() => {
    socketStore.removeListener(event, callBack);
  });
}
